import { Component, Input } from '@angular/core';
import {
  DEFAULT_APPLICATION_PHONE_NUMBER,
  ROCKET_MORTGAGE_CLOSING_TEAM_NUMBER,
} from 'src/app/features/shared/constants';
import { FaqWidgetService } from 'src/app/features/help-faq';
import { FeatureManagementService } from 'src/app/features/feature-management/services';
import { Feature } from 'src/app/features/feature-management/models';
import { Store } from '@ngrx/store';
import { getHasAssociatedUsers } from 'src/app/features/help-faq/store/selectors/help-faq.selectors';

@Component({
    selector: 'app-support-phone-number-button',
    templateUrl: './support-phone-number-button.component.html',
    styleUrls: ['../../nav-bar.component.scss'],
    standalone: false
})
export class SupportPhoneNumberButtonComponent {
  @Input() showPhoneNumber = true;
  techSupportNumber = DEFAULT_APPLICATION_PHONE_NUMBER;
  documentAndLoanNumber = ROCKET_MORTGAGE_CLOSING_TEAM_NUMBER;

  protected readonly hasAssociatedUsers = this.store.selectSignal(getHasAssociatedUsers);

  get showFaqButton(): boolean {
    return this.hasAssociatedUsers() &&
      this.featureManagementService.getIsFeatureEnabledWithCaching(Feature.HelpFaqWidget) === true;
  }

  constructor(
    private readonly faqWidgetService: FaqWidgetService,
    private readonly featureManagementService: FeatureManagementService,
    private readonly store: Store
  ) {}

  openFaqs(): void {
    this.faqWidgetService.open();
  }

  /** Builds a tel: href from a display-formatted phone number. */
  telHref(phoneNumber: string): string {
    return 'tel:' + phoneNumber.replace(/[^\d+]/g, '');
  }
}
